export default __webpack_public_path__ + "img/Square_0.a2883212c8f7b4936460815f0919d30d.jpg";